import { Modal, TextField } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { configs } from '../../../assets/Config';
import '../../../assets/styles/RM.css'
import { addCorporateActionData, uploadCompanyDataDoc } from '../../../services/apis/companyManagement/CMApi';
import { useLogin } from '../../../services/contexts/AdminLoginContext';
import { useCMContext } from '../../../services/contexts/companyManagement/CMContext';
import RichTextEditorPage from '../../includes/RichTextEditorPage';
import { Autocomplete } from '@material-ui/lab';

export default function CreateCorpActionPage() {

    const { setShowSuccess, token, logout, setLoginError, allowedFunc } = useLogin()
    const { editCompany, setEditCompany, editCompanyData, setEditCompanyData, createEditCompany, getAllCompaniesList, setShowRTPage, showRTPage, setOverview, setInsight, setAnnualReport, companyList, getAllCorporateActionList } = useCMContext()



    const [error, setError] = useState("")
    const [companyId, setCompanyId] = useState("");
    const [actionType, setActionType] = useState("");
    const [recordDate, setRecordDate] = useState("");
    const [value, setValue] = useState("");
    const [remark, setRemark] = useState("");

    const history = useHistory()

    // add company function
    async function addCompany() {
        try {
            document.getElementById("companyBtn").classList.toggle("d-none")
            document.getElementById("companyBtnLoader").classList.toggle("d-none")

            if (!companyId) {
                setError("Please select a valid company.")
            } else if (!actionType) {
                setError("Please select a valid corporate action.")
            } else if (!recordDate) {
                setError("Please select a valid date.")
            } else if (!value) {
                setError("Please provide a valid value.")
            } else if (!remark) {
                setError("Please provide a valid remark.")
            } else {
                let response = await addCorporateActionData(token, companyId, actionType, recordDate, value, remark)
                if (response && response.status === 200) {
                    resetValues()
                    setShowSuccess(true)
                    getAllCorporateActionList()
                } else if (response && response.status === 401) {
                    logout();
                    setLoginError(configs.unauthorizedErrorMessage);
                }
                else {
                    setError(response.data.error)
                }
            }

            document.getElementById("companyBtn").classList.toggle("d-none")
            document.getElementById("companyBtnLoader").classList.toggle("d-none")
        } catch (error) {
        }
    }

    // reset all values
    function resetValues() {
        try {
            setError("");
            setCompanyId("");
            setActionType("");
            setRecordDate("");
            setValue("");
            setRemark("");
        } catch (error) {

        }
    }


    const handleCompanyChange = async (e, value) => {
        try {
            setCompanyId(value.id)
        } catch (error) {
            console.error(error);
        }
    }


    // create role ui code
    return (
        <div id="rmCreateCompany" className="col-lg-3 col-md-4 d-md-block d-none pt-3 main-rmPanel">
            {((allowedFunc.includes(configs.functionList["company_management:update_company"]) && editCompany) || allowedFunc.includes(configs.functionList["company_management:create_company"])) ?
                <>
                    <p className="h6 text-custom-grey">Add Corporate Action</p>

                    <div className="function-container">
                        <form id="createRoleForm" action="" className='mr-1'>
                            <div className="form-group">
                                <label className="f-12">Company Name</label>
                                {companyList ? <Autocomplete
                                    className="f-12"
                                    id="companyIP"
                                    placeholder="Compnay Name"
                                    getOptionLabel={option => option.name}
                                    onChange={handleCompanyChange}
                                    options={companyList}
                                    value={companyList.find(item => item.id === companyId) || ""}
                                    renderInput={(params) => <TextField {...params} placeholder="Company Name" className="f-12" />}
                                /> : null}
                            </div>
                            <div className="form-group">
                                <label className="f-12">Select Action</label>
                                <select name="" id="" className="col-12 py-1 px-2 border rounded" value={actionType ? actionType : "default"} onChange={(e) => {
                                    setActionType(e.target.value)
                                }}>
                                    <option value="default" disabled> -- Select an Action -- </option>
                                    <option value="DIVIDEND">Dividend</option>
                                    <option value="BONUS">Bonus</option>
                                    <option value="SPLIT">Split</option>

                                </select>
                            </div>
                            <div className="form-group">
                                <label className="f-12">Record Date</label>
                                <input type="date" id="listingDate" className="form-control f-10" placeholder="Record Date" value={recordDate} onChange={(e) => {
                                    setRecordDate(e.target.value)
                                }} />
                            </div>
                            <div className="form-group">
                                <label className="f-12">Data</label>
                                <input type="text" id="listingPrice" className="form-control f-10" placeholder="Data" value={value} onChange={(e) => {
                                    setValue(e.target.value)
                                }} />
                            </div>
                            <div className="form-group">
                                <label className="f-12">Remark</label>
                                <input type="text" id="roleName" className="form-control f-10" placeholder="Remark" value={remark} required onChange={(e) => {
                                    setRemark(e.target.value)
                                }} />
                            </div>
                        </form>
                    </div>
                    <div className="form-check p-0">
                        <p className="text-danger" id="createRoleError">{error}</p>
                    </div>
                    <div className='row m-0 p-0'>
                        <div className='col-9 m-0 p-0'>
                            <button id="companyBtn" className="btn btn-primary f-12" onClick={(e) => {
                                e.preventDefault()
                                addCompany()
                            }}>Add Corporate Action</button>
                            <div id="companyBtnLoader" className='animBtn d-none'><div className='gSignIn-Anim'></div></div>
                        </div>
                        <div className='col-3 m-0 p-0'>
                            <button className="btn btn-primary f-12" onClick={(e) => {
                                e.preventDefault()
                                resetValues()
                            }}>Reset</button>
                        </div>
                    </div>
                    <div className='row m-0 p-0'>
                        <button className="btn btn-primary mt-3 d-md-none" onClick={(e) => {
                            e.preventDefault()
                            document.getElementById("rmCreateCompany").classList.toggle('d-none')
                            document.getElementById("companyListPage").classList.toggle('d-none')
                            history.push('/companyManagement/companyDetail')
                        }}>View All Data</button>
                    </div>
                </>
                : null}
        </div>
    )
}